var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThinArrowPurple = function SvgThinArrowPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 21 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6676D6",
    strokeWidth: 4,
    d: "M1.843 2 18 17 1.843 32"
  })));
};
export { SvgThinArrowPurple as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMSAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuODQzMjYgMkwxOCAxN0wxLjg0MzI2IDMyIiBzdHJva2U9IiM2Njc2RDYiIHN0cm9rZS13aWR0aD0iNCIvPgo8L3N2Zz4K";